import React, { Fragment, useState, useEffect, useRef } from "react";
import { useKeenSlider } from "keen-slider/react";
import useWindowSize from "../Helpers/WindowSize";
import { add as addToCartService } from '../Services/Cart.service';
import { receive, loadError } from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';
import { useDispatch } from 'react-redux';

import("keen-slider/keen-slider.min.css");


export default function ProductSlider(props) {
    const dispatch = useDispatch();
    const [stateClass, setStateClass] = useState('');
    const [currentSlide, setCurrentSlide] = useState(0);
    const [slidesPerView, setSlidesPerView] = useState(4);
    const [windowWidth] = useWindowSize();
    const [sliderRef, slider] = useKeenSlider({
        slidesPerView: slidesPerView,
        loop: false,
        slideChanged(s) {
            setCurrentSlide(s.details().relativeSlide)
        },
        breakpoints: {
            "(max-width: 1024px)": {
                slidesPerView: 1.75
            },
        },
    });

    const stylePrefix = 'buy-button-in-slider';
    const StateStyles = {
        LOADING: '--loading',
        SUCCESS: '--success',
        ERROR: '--error',
    };

    const startTime = useRef(0);

    function onNeutralState(el) {
        startTime.current = 0;
        el.classList.remove(...el.classList);
    }

    function onLoadingState(el) {
        el.classList.add(`${stylePrefix}${StateStyles.LOADING}`);
        startTime.current = Date.now();
    }

    const changeState = (el, complete, loadTime = 0) => {
        loadTime = loadTime > 0 ? loadTime : 1000;

        el.classList.add(
            `${stylePrefix}${
                complete ? StateStyles.SUCCESS : StateStyles.ERROR
            }`);

        setTimeout(() => {
            onNeutralState(el);
        }, loadTime);
    };

    function onComplete(complete, state) {
        const loadingDuration = Date.now() - startTime.current;
        const minimumLoadingTime = props.minimumLoadingTime || 1000;
        // ensure the loading indicator is displayed at least a `minimumLoadingTime`
        // amount of time before changing it to Success or Error.
        if (loadingDuration >= minimumLoadingTime) {
            changeState(complete, state);
        } else {
            setTimeout(() => {
                changeState(complete, state, minimumLoadingTime - loadingDuration)
            }, minimumLoadingTime - loadingDuration);
        }
    }

    var getSlides = () => {
        return props.children.map((child, i) => {
            return <div className="keen-slider__slide product-list__item column" key={"keen-slider-item" + i}> <div className="product__wrapper" onClick={(e) => handleClickInDSIH(e)} itemType="http://schema.org/Product" dangerouslySetInnerHTML={{__html: child.innerHTML}} ></div></div>
        });
    }

    const handleClickInDSIH = e => {
        //workaround for onclick because it can't be sent as a function in the dangerouslySetInnerHTML attribute
        let buttonParent = e.target.closest("buy-button");
        if(buttonParent){
            onLoadingState(buttonParent);
            var articleNumber = buttonParent.dataset.articleNumber;
            var quantityFieldId = buttonParent.dataset.quantityFieldId
            var packageQuantity = buttonParent.dataset.packageQuantity;

            var quant = quantityFieldId * packageQuantity;

            onClick({articleNumber, quant});
            onComplete(buttonParent, true);
        }
    }

    const onClick = async ({ articleNumber, quantityFieldId }) => {

        try {
            const quantity = quantityFieldId
                ? document.getElementById(quantityFieldId).value
                : 1;
            const cart = await addToCartService({ articleNumber, quantity });
            dispatch(receive(cart));
            return true;
        } catch (ex) {
            dispatch(catchError(ex, (error) => loadError(error)));
            return false;
        }
    };

    const prevSlide = e => {
        e.stopPropagation();
        slider.prev();
    }

    const nextSlide = e => {
        e.stopPropagation();
        slider.next();
    }

    return(
        <div className="row keen-slider-wrapper keen-slider-wrapper--show-overflow">
            <div className="keen-slider custom-scroll-mobile" ref={sliderRef}>
                {getSlides()}
            </div>
            {(slider &&  windowWidth > 500) && 
            <>
                <div className="keen-slider__arrow keen-slider__arrow--left" onClick={(e) => prevSlide(e)} hidden={currentSlide == 0}>
                    <i className="icon-chevron-left"></i>
                </div>
                <div className="keen-slider__arrow keen-slider__arrow--right" onClick={(e) => nextSlide(e)} hidden={currentSlide >= slider.details().size - Math.floor(slidesPerView)}>
                    <i className="icon-chevron-right"></i>
                </div>
            </>}
    </div>
    );
}